module.exports = __webpack_public_path__ + "static/img/networkErr.d71c8d9.png";